import styled from 'styled-components';


const StyledPayFailWelcome = styled.div`
 @import url("https://fonts.googleapis.com/css2?family=Nunito&family=Roboto+Slab:wght@900&display=swap");


 /* background-color: #ffffff;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%238d6139' fill-opacity='0.03'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"); */


h1 {
  font-family: "Roboto Slab", serif;
  color: var(--primary);
}

ul {
  list-style: none;
}

#imgBkg {
position: fixed;
top: -7.5em;
  /* width: 100vw; */
  height: 80vh;
  z-index: -1;
  transform: scale(1.2,1.2);
}


.hero-section {
    position: fixed;
    width: 72vw;
    height: 24.75em;
    left: 50%;
    top: 36%;
    transform: translate3d(-50%,0,0);
    background: rgba(245,245,245,0.85);
    padding: 0.75em;
   
}
.hero-section h3{
    color: #8C683C;
    font-size: 2.5em;
    font-family: 'Playfair Display', serif;
    text-align: center;
    max-width: 10ch;
    margin: auto;
    padding: 0.67em 0;
    line-height:1.2;
}
.hero-section p{
    font-size: 1.14em;
    text-align: center;
    letter-spacing: 0.002em;
    max-width: 28ch;
    margin: auto;
    font-family: "Roboto";
}

.hero-section p > a{
    color: #111;
    text-decoration: none;
    font-weight: bold;
}

.hero-section .hero-welcome-footer {
    display: flex;
    flex-direction: column;
    margin: auto;
    height: 12.5vh;
    width: 100%;
    align-items: center;
    justify-content: center;
}
.contact-link {
    color: #8C683C;
    text-decoration: none;
}


@media screen and (min-width: 525px){
    .hero-section {
        width: 30vw;
    }
    #imgBkg {
    transform: scale(1.25,1.25);
    }
}
/* MEDIA QUERIES for img background
----------------------------------------- */
@media (min-aspect-ratio: 16/9) {
  #imgBkg {
    width: 100vw;
    height: auto;
  }
  
}

@media (max-aspect-ratio: 16/9) {
  #imgBkg {
    width: 100vw;
    height: 67vh;
  }
}



`;

export default StyledPayFailWelcome